import { Injector } from "@angular/core";
import { Art57Node } from "../Art57Node";
import { FieldDefinition } from "../../../../../sections/createSendProductReport/message/fieldDefinition";
import { DrugRoute } from "../../../Data/Art57Data/DrugRoute";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { CodeName } from "../../../../service/lookup-service/code-name.model";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { ErrorType } from "../../ErrorType";
import { environment } from "../../../../../../environments/environment";
import { ErrorControlUtil } from "../../../ErrorControlUtil";

export class TreeNodeDrugRoute extends Art57Node {
    constructor(injector: Injector, parent: Art57Node) {
      super(
        injector,
        new DrugRoute(new FieldDefinition(injector)),
        'Drug Route'
      );
      this.parent = parent;
      this.labelNodeName = 'Route Of Administration';      
      this.ioc!.get(Art57Section).generateNumColumValue(this);
      this.refreshLabel();
    }
  
    override refreshLabel(lazy:boolean=true): void {
      if (this.data && this.data.model &&
        this.data.model.adminroutecode &&
        this.data.model.adminroutecode.value) {
          if (this.data.model.adminroutecode.name) {
            this.label = this.data.model.adminroutecode.name;                
          
          } else if (!lazy) {
            this.ioc!.get(LookupGetService).getLookup('adminroute',this.data.model.adminroutecode.value)
            .then((result: CodeName) => {
              if (result && result.name && result.name != '') {
                this.data.model.adminroutecode.name = result.name;
                this.refreshLabel();
              } else {
                this.label = this.labelTemplate;
              }
            });
          }   
        } else {
          this.label = this.labelTemplate;
        } 

    }
  
    override cloneNode(newParent: Art57Node): Art57Node {
      let clonedNode: TreeNodeDrugRoute = new TreeNodeDrugRoute(
        this.ioc!,
        newParent
      );
  
      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

  
      return clonedNode;
    }
  
    override getListItem(): any[] {
      return [
        this.data.model &&
          this.data.model.adminroutecode &&
          this.data.model.adminroutecode.name
          ? this.data.model.adminroutecode.name
          : this.label,
      ];
    }

    override validateBusinessRules(): any[] {
      const sameModelValuesBusinessErrors = ErrorControlUtil.sameModelValues(this);
      let businessRulesErrors = [];

      if (sameModelValuesBusinessErrors.length>0){
        businessRulesErrors.push(...sameModelValuesBusinessErrors);
      }

       return businessRulesErrors;
    }
   
  }
  